module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-02-m.323e7c52afc787aadd5b0662d16fa8fc.png";